import * as React from "react";
import "./App.css";
import { Admin, Resource } from "react-admin";
import { dataProvider } from "./data/dataProvider";
import { AdminUserCreate, AdminUserEdit, AdminUserList, AdminUserShow } from "./panels/adminUsers/AdminUsers";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import PersonIcon from "@material-ui/icons/Person";
import _LoginPage from "./components/LoginPage";
import { AuthProvider } from "./auth/authProvider";
import { MyTheme } from "./style/theme";
import { i18nProvider } from "./i18n/i18nProvider";
import MyLayout from "./components/Layout";
import Dashboard from "./panels/dashboard/Dashboard";
import { AdviceCreate, AdviceEdit, AdviceList, AdviceShow } from "./panels/advice/Advice";
import SpeakerNotesIcon from "@material-ui/icons/SpeakerNotes";
import { ROLES } from "./constants";
import { MenuCategories } from "./constants/menuCategories";
import { BlogCreate, BlogEdit, BlogList, BlogShow } from "./panels/blog/Blog";
import ForumIcon from "@material-ui/icons/Forum";
import CategoryIcon from "@material-ui/icons/Category";
import { BlogCategoryCreate, BlogCategoryEdit, BlogCategoryList, BlogCategoryShow } from "./panels/blogCategory/BlogCategory";
import { RTL } from "./style/rtl";
import { UserShow, UserList, UserEdit } from "./panels/user/User";
import { ConfigEdit, ConfigList, ConfigShow, CreateConfig } from "./panels/config/config";
import { PeriodList } from "./panels/period/period";
import { CodeList } from "./panels/codes/code";
import { ForumCategoryCreate, ForumCategoryEdit, ForumCategoryList, ForumCategoryShow } from "./panels/forumCategory/ForumCategory";
import { ForumCreate, ForumEdit, ForumList, ForumShow } from "./panels/forum/Forum";
import { ReportList, ReportShow } from "./panels/report/Report";
import { AddComment, AttachMoney, History, Receipt, Report, Assignment } from "@material-ui/icons";
import { SpecialistCardCreate, SpecialistCardEdit, SpecialistCardList, SpecialistCardShow } from "./panels/specialistCard/SpecialistCard";
import {
  SpecialistCommentEdit,
  SpecialistCommentList,
  SpecialistCommentShow
} from "./panels/specialistComment/SpecialistComment";
import { InvoiceEdit, InvoiceList, InvoiceShow } from "./panels/invoice/Invoice";
import { AdminLogHistoryList, AdminLogHistoryShow } from "./panels/adminLogHistory/AdminLogHistory";
import { UserConversationCreate, UserConversationEdit, UserConversationList, UserConversationShow } from "./panels/userConversation/UserConversation";
import { AttachmentList, AttachmentShow } from "./panels/attachment/Attachment";
import {MessageEdit, MessageList, MessageShow} from "./panels/message/Message";
import { ConversationCreate, ConversationEdit, ConversationList, ConversationShow } from "./panels/conversation/Conversation";
import { SpecialistSalesReportList } from "./panels/specialistSalesReport/SpecialistSalesReport";
import {
  SpecialistTransactionList,
  SpecialistTransactionShow
} from "./panels/specialistTransaction/SpecialistTransaction";
import {
  ConversationAdCreate,
  ConversationAdEdit,
  ConversationAdList,
  ConversationAdShow
} from "./panels/conversationAd/ConversationAd";
import {AvatarCreate, AvatarEdit, AvatarList, AvatarShow} from "./panels/avatar/Avatar";
import {
  ExperimentList,
  ExperimentShow,
  ExperimentEdit,
  ExperimentCreate
} from "./panels/experiment/Experiment";
import {VariantCreate, VariantEdit, VariantList, VariantShow} from "./panels/variant/Variant";
import {UserVariantCreate, UserVariantEdit, UserVariantList, UserVariantShow} from "./panels/userVariant/UserVariant";
import {ChildWeekCreate, ChildWeekEdit, ChildWeekList, ChildWeekShow} from "./panels/childWeek/ChildWeek";
import {MarketLoginCreate, MarketLoginEdit, MarketLoginList, MarketLoginShow} from "./panels/marketLogin/MarketLogin";
import {WelcomeModalCreate, WelcomeModalEdit, WelcomeModalList, WelcomeModalShow} from "./panels/welcomeModal/WelcomeModal";
import {
  TermsConditionCreate,
  TermsConditionEdit,
  TermsConditionList,
  TermsConditionShow
} from "./panels/termsCondition/TermsCondition";
import {PlanCreate, PlanEdit, PlanList, PlanShow} from "./panels/plan/Plan";
import {PlanTypeCreate, PlanTypeEdit, PlanTypeList, PlanTypeShow} from "./panels/planType/PlanType";
import {PromotionCreate, PromotionEdit, PromotionList, PromotionShow} from "./panels/promotion/Promotion";
import {DiscountCreate, DiscountEdit, DiscountList, DiscountShow} from "./panels/discount/Diacount";
import {BulkDiscountCreate, BulkDiscountList, BulkDiscountShow} from "./panels/bulkDiscount/BulkDiacount";
import {
  PlanFeaturesCreate,
  PlanFeaturesEdit,
  PlanFeaturesList,
  PlanFeaturesShow
} from "./panels/planFeatures/planFeatures";
import {EventBannerCreate, EventBannerEdit, EventBannerList, EventBannerShow} from "./panels/eventBanner/eventBanner";
import {
  SubscriptionCreate,
  SubscriptionEdit,
  SubscriptionList,
  SubscriptionShow
} from "./panels/subscription/Subscription";

const App = () => (
  <RTL>
    <Admin
      loginPage={_LoginPage}
      dataProvider={dataProvider}
      authProvider={AuthProvider}
      theme={MyTheme}
      i18nProvider={i18nProvider}
      title="Luna Admin Panel"
      layout={MyLayout}
      dashboard={Dashboard}
    >
      <Resource
        name="adminUsers"
        dataProvider={dataProvider}
        list={AdminUserList}
        create={AdminUserCreate}
        edit={AdminUserEdit}
        show={AdminUserShow}
        icon={<VerifiedUserIcon />}
        options={{ category: MenuCategories.admin, label: "مدیران", permission: ROLES.SUPER_ADMIN }}
      />

      <Resource
          name="termsCondition"
          dataProvider={dataProvider}
          list={TermsConditionList}
          create={TermsConditionCreate}
          edit={TermsConditionEdit}
          show={TermsConditionShow}
          icon={<SpeakerNotesIcon />}
          options={{ category: MenuCategories.content, label: "قوانین", permission: ROLES.SUPER_ADMIN }}
      />

      <Resource
        name="user"
        dataProvider={dataProvider}
        list={UserList}
        show={UserShow}
        edit={UserEdit}
        icon={<PersonIcon />}
        options={{ category: MenuCategories.user, label: "کاربران", permission: ROLES.USERS_ADMIN }}
      />

      <Resource
          name="plan"
          dataProvider={dataProvider}
          create={PlanCreate}
          list={PlanList}
          show={PlanShow}
          edit={PlanEdit}
          icon={<Receipt />}
          options={{ category: MenuCategories.shop, label: "پلن‌ها", permission: ROLES.USERS_ADMIN }}
      />

      <Resource
          name="planType"
          dataProvider={dataProvider}
          create={PlanTypeCreate}
          list={PlanTypeList}
          show={PlanTypeShow}
          edit={PlanTypeEdit}
          icon={<Receipt />}
          options={{ category: MenuCategories.shop, label: "نوع پلن‌ها", permission: ROLES.USERS_ADMIN }}
      />

      <Resource
          name="promotion"
          dataProvider={dataProvider}
          create={PromotionCreate}
          list={PromotionList}
          show={PromotionShow}
          edit={PromotionEdit}
          icon={<Receipt />}
          options={{ category: MenuCategories.shop, label: "پروموشن", permission: ROLES.USERS_ADMIN }}
      />

      <Resource
          name="subscription"
          dataProvider={dataProvider}
          create={SubscriptionCreate}
          list={SubscriptionList}
          show={SubscriptionShow}
          edit={SubscriptionEdit}
          icon={<Receipt />}
          options={{ category: MenuCategories.shop, label: "سابسکریپشن", permission: ROLES.USERS_ADMIN }}
      />

      <Resource
          name="discount"
          dataProvider={dataProvider}
          create={DiscountCreate}
          list={DiscountList}
          show={DiscountShow}
          edit={DiscountEdit}
          icon={<Receipt />}
          options={{ category: MenuCategories.shop, label: "کدتخفیف", permission: ROLES.USERS_ADMIN }}
      />

      <Resource
          name="bulkDiscount"
          dataProvider={dataProvider}
          create={BulkDiscountCreate}
          list={BulkDiscountList}
          show={BulkDiscountShow}
          icon={<Receipt />}
          options={{ category: MenuCategories.shop, label: "کدتخفیف انبوه", permission: ROLES.USERS_ADMIN }}
      />

      <Resource
          name="planFeatures"
          dataProvider={dataProvider}
          create={PlanFeaturesCreate}
          list={PlanFeaturesList}
          show={PlanFeaturesShow}
          edit={PlanFeaturesEdit}
          icon={<Receipt />}
          options={{ category: MenuCategories.shop, label: "ویژگی‌های پلن", permission: ROLES.USERS_ADMIN }}
      />

      <Resource
          name="eventBanner"
          dataProvider={dataProvider}
          create={EventBannerCreate}
          list={EventBannerList}
          show={EventBannerShow}
          edit={EventBannerEdit}
          icon={<Receipt />}
          options={{ category: MenuCategories.shop, label: "بنر رویداد", permission: ROLES.USERS_ADMIN }}
      />

      <Resource
          name="periods"
          dataProvider={dataProvider}
          list={PeriodList}
          icon={<SpeakerNotesIcon />}
          options={{ category: MenuCategories.userLogs, label: "پریودها", permission: ROLES.USERS_ADMIN }}
      />

      <Resource
        name="advice"
        dataProvider={dataProvider}
        list={AdviceList}
        create={AdviceCreate}
        edit={AdviceEdit}
        show={AdviceShow}
        icon={<SpeakerNotesIcon />}
        options={{ category: MenuCategories.advice, label: "توصیه‌ها", permission: ROLES.MARKETING_ADMIN }}
      />

      <Resource
          name="marketLogin"
          dataProvider={dataProvider}
          list={MarketLoginList}
          create={MarketLoginCreate}
          edit={MarketLoginEdit}
          show={MarketLoginShow}
          icon={<SpeakerNotesIcon />}
          options={{ category: MenuCategories.admin, label: "لاگین مارکت", permission: ROLES.MARKETING_ADMIN }}
      />

      <Resource
        name="blog"
        dataProvider={dataProvider}
        list={BlogList}
        create={BlogCreate}
        edit={BlogEdit}
        show={BlogShow}
        icon={<SpeakerNotesIcon />}
        options={{ category: MenuCategories.blog, label: "بلاگ‌ها", permission: ROLES.MARKETING_ADMIN }}
      />

      <Resource
        name="blogCategory"
        dataProvider={dataProvider}
        list={BlogCategoryList}
        create={BlogCategoryCreate}
        edit={BlogCategoryEdit}
        show={BlogCategoryShow}
        icon={<SpeakerNotesIcon />}
        options={{ category: MenuCategories.blog, label: "دسته‌های بلاگ‌ها", permission: ROLES.MARKETING_ADMIN }}
      />

      <Resource
        name="forumCategory"
        dataProvider={dataProvider}
        list={ForumCategoryList}
        create={ForumCategoryCreate}
        edit={ForumCategoryEdit}
        show={ForumCategoryShow}
        icon={<CategoryIcon />}
        options={{ category: MenuCategories.forum, label: "دسته‌های فروم‌ها", permission: ROLES.MARKETING_ADMIN }}
      />

      <Resource
        name="forum"
        dataProvider={dataProvider}
        list={ForumList}
        create={ForumCreate}
        edit={ForumEdit}
        show={ForumShow}
        icon={<ForumIcon />}
        options={{ category: MenuCategories.forum, label: "فروم‌ها", permission: ROLES.MARKETING_ADMIN }}
      />

      <Resource
        name="config"
        dataProvider={dataProvider}
        list={ConfigList}
        create={CreateConfig}
        edit={ConfigEdit}
        show={ConfigShow}
        icon={<SpeakerNotesIcon />}
        options={{ category: MenuCategories.admin, label: "کانفیگ", permission: ROLES.MARKETING_ADMIN }}
      />

      <Resource
        name="report"
        dataProvider={dataProvider}
        list={ReportList}
        show={ReportShow}
        icon={<Report />}
        options={{ category: MenuCategories.conversation, label: "ریپورت‌های کاربران", permission: ROLES.MARKETING_ADMIN }}
      />

      <Resource
        name="adminLogHistory"
        dataProvider={dataProvider}
        list={AdminLogHistoryList}
        show={AdminLogHistoryShow}
        icon={<History />}
        options={{ category: MenuCategories.admin, label: "تاریخچه فعالیت", permission: ROLES.MARKETING_ADMIN }}
      />

      <Resource
          name="avatar"
          dataProvider={dataProvider}
          list={AvatarList}
          show={AvatarShow}
          create={AvatarCreate}
          edit={AvatarEdit}
          icon={<PersonIcon />}
          options={{ category: MenuCategories.avatar, label: "آواتارها", permission: ROLES.MARKETING_ADMIN }}
      />

      <Resource
        name="specialistCard"
        dataProvider={dataProvider}
        list={SpecialistCardList}
        create={SpecialistCardCreate}
        edit={SpecialistCardEdit}
        show={SpecialistCardShow}
        icon={<AttachMoney />}
        options={{ category: MenuCategories.specialists, label: "پلن پزشکان", permission: ROLES.MARKETING_ADMIN }}
      />

      <Resource
        name="specialistComment"
        dataProvider={dataProvider}
        list={SpecialistCommentList}
        show={SpecialistCommentShow}
        edit={SpecialistCommentEdit}
        icon={<AddComment />}
        options={{ category: MenuCategories.specialists, label: "نظرات کاربران", permission: ROLES.MARKETING_ADMIN }}
      />

      <Resource
        name="invoice"
        dataProvider={dataProvider}
        list={InvoiceList}
        edit={InvoiceEdit}
        show={InvoiceShow}
        icon={<Receipt />}
        options={{ category: MenuCategories.shop, label: "صورت‌حساب‌ها", permission: ROLES.USERS_ADMIN }}
      />

      <Resource
        name="codes"
        dataProvider={dataProvider}
        list={CodeList}
        icon={<PersonIcon />}
        options={{ category: MenuCategories.user, label: "کدهای ورود", permission: ROLES.USERS_ADMIN }}
      />
      <Resource
        name="specialistSalesReport"
        dataProvider={dataProvider}
        list={SpecialistSalesReportList}
        icon={<Assignment />}
        options={{ category: MenuCategories.specialists, label: "گزارش پزشکان", permission: ROLES.USERS_ADMIN }}
      />

      <Resource
        name="specialistTransaction"
        dataProvider={dataProvider}
        list={SpecialistTransactionList}
        show={SpecialistTransactionShow}
        icon={<PersonIcon />}
        options={{ category: MenuCategories.shop, label: "کارت‌های‌ صورت حساب‌ها‌", permission: ROLES.USERS_ADMIN }}
      />

      <Resource
        name="conversation"
        dataProvider={dataProvider}
        list={ConversationList}
        create={ConversationCreate}
        edit={ConversationEdit}
        show={ConversationShow}
        icon={<VerifiedUserIcon />}
        options={{ category: MenuCategories.conversation, label: "مکالمه‌ها", permission: ROLES.SUPER_ADMIN }}
      />

      <Resource
        name="message"
        dataProvider={dataProvider}
        list={MessageList}
        show={MessageShow}
        edit={MessageEdit}
        icon={<VerifiedUserIcon />}
        options={{ category: MenuCategories.conversation, label: "پیام‌ها", permission: ROLES.SUPER_ADMIN }}
      />

      <Resource
        name="attachment"
        dataProvider={dataProvider}
        list={AttachmentList}
        show={AttachmentShow}
        icon={<VerifiedUserIcon />}
        options={{ category: MenuCategories.conversation, label: "پیوست‌ها", permission: ROLES.SUPER_ADMIN }}
      />

      <Resource
        name="userConversation"
        dataProvider={dataProvider}
        list={UserConversationList}
        create={UserConversationCreate}
        edit={UserConversationEdit}
        show={UserConversationShow}
        icon={<VerifiedUserIcon />}
        options={{ category: MenuCategories.conversation, label: "کاربران مکالمه", permission: ROLES.SUPER_ADMIN }}
      />

      <Resource
          name="conversationAd"
          dataProvider={dataProvider}
          list={ConversationAdList}
          create={ConversationAdCreate}
          edit={ConversationAdEdit}
          show={ConversationAdShow}
          icon={<VerifiedUserIcon />}
          options={{ category: MenuCategories.ads, label: "تبلیغات دورهمی", permission: ROLES.SUPER_ADMIN }}
      />
      <Resource
        name="experiment"
        dataProvider={dataProvider}
        list={ExperimentList}
        create={ExperimentCreate}
        edit={ExperimentEdit}
        show={ExperimentShow}
        icon={<VerifiedUserIcon />}
        options={{ category: MenuCategories.abtest, label: "آزمایش ها", permission: ROLES.SUPER_ADMIN }}
      />
      <Resource
      name="variant"
      dataProvider={dataProvider}
      list={VariantList}
      create={VariantCreate}
      edit={VariantEdit}
      show={VariantShow}
      icon={<VerifiedUserIcon />}
      options={{ category: MenuCategories.abtest, label: "متغییر ها", permission: ROLES.SUPER_ADMIN }}
    />
      <Resource
        name="userVariant"
        dataProvider={dataProvider}
        list={UserVariantList}
        create={UserVariantCreate}
        edit={UserVariantEdit}
        show={UserVariantShow}
        icon={<VerifiedUserIcon />}
        options={{ category: MenuCategories.abtest, label: "متغییر و کاربران ها", permission: ROLES.SUPER_ADMIN }}
      />
      <Resource
        name="childWeek"
        dataProvider={dataProvider}
        list={ChildWeekList}
        create={ChildWeekCreate}
        edit={ChildWeekEdit}
        show={ChildWeekShow}
        icon={<VerifiedUserIcon />}
        options={{ category: MenuCategories.pregnancy, label: "مدیریت هفته های جنین", permission: ROLES.SUPER_ADMIN }}
      />
      <Resource
        name="welcomeModal"
        dataProvider={dataProvider}
        list={WelcomeModalList}
        create={WelcomeModalCreate}
        edit={WelcomeModalEdit}
        show={WelcomeModalShow}
        icon={<VerifiedUserIcon />}
        options={{ category: MenuCategories.ads, label: "مودال خوش آمدید", permission: ROLES.SUPER_ADMIN }}
    />
    </Admin>
  </RTL>
);

export default App;
